import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useClientId } from '../../_hooks/useClientId';
import { useFpId } from '../hooks/useFpId';
import { queryKeys } from './queryKeys';

export enum PlanSeriesName {
  Confidence50 = 'Confidence50',
  Confidence90 = 'Confidence90',
}

export interface ChartDataDTO {
  Categories: string[];
  Series: {
    [PlanSeriesName.Confidence50]: number[];
    [PlanSeriesName.Confidence90]: number[];
  };
}

interface ImpactRow {
  Label: string;
  Current: string;
  Proposed: string;
}

interface DecumulationGoalDTO {
  chartData: ChartDataDTO;
  whatIfPlanImpact: ImpactRow[];
}

interface FetcherParams {
  clientId: number;
  fpId: string;
}

const fetchDecumulationGoal = async (
  { clientId, fpId }: FetcherParams,
  signal?: AbortSignal,
): Promise<DecumulationGoalDTO> => {
  return authFetch(
    urlWithParams('/Consumer/MC/Decumulation', {
      clientId,
      fpId,
    }),
    { signal },
  );
};

export const useDecumulationGoalQuery = () => {
  const clientId = useClientId();
  const fpId = useFpId();

  return useQuery(
    queryKeys.decumulationGoal(clientId, fpId),

    ({ signal }) => fetchDecumulationGoal({ clientId, fpId }, signal),

    {
      cacheTime: 0,
    },
  );
};
